class ProjectFilter {
  constructor() {
    if(document.querySelector('.js-projects') == null) return
    this.initialize()
  }

  initialize() {
    this.bindUI()
    this.bindEvents()
  }

  bindUI() {
    this.el = document.querySelector('.js-projects')
    this.filters = this.el.querySelectorAll('.js-projects-filter')
    this.projects = this.el.querySelectorAll('.js-projects-post')
    this.view = this.el.querySelector('.js-in-view')
  }

  bindEvents() {
    for (let i = 0; i < this.filters.length; i++) {
      this.filters[i].addEventListener('click', this.onClick.bind(this))
    }
  }

  onClick(e) {
    const target = e.target
    if(!target.matches('.js-projects-filter')) return

    const type = target.getAttribute('data-type')

    for (let j = 0; j < this.filters.length; j++) {
      this.filters[j].classList.remove('is-active')
    }
    
    for (let i = 0; i < this.projects.length; i++) {
      let projectType = this.projects[i].getAttribute('data-type')
      this.projects[i].classList.remove('u-is-hidden')

      this.projects[i].classList.add('fade-out')
      setTimeout(() => {
        this.view.classList.remove('is-visible')
        this.projects[i].classList.remove('fade-out')
        if(projectType != type) {
          target.classList.add('is-active')
          this.projects[i].classList.add('u-is-hidden')
        }
      }, 500)

      setTimeout(() => {
        this.view.classList.add('is-visible')
      }, 1200)
    }
  }
}

export default ProjectFilter
